import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { useGetCoSupervisorInformation } from '../../../graphql';
import { Alert, Loading, ROLES_MODULE } from '../../../../../components';
import { TokenType, useAuth, type User } from '../../../../../contexts';

export const TokenProtectLogin: React.FunctionComponent = () => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token') ?? '';
  const { setUser, user, setCurrentRole } = useAuth();
  const navigate = useNavigate();

  const { coSupervisorInformation, guestLoginData, loading, error } =
    useGetCoSupervisorInformation(token);
  const { applicationId, nominationId, emailAddress } = coSupervisorInformation;

  if (!loading && guestLoginData !== null) {
    const newUser: User = jwt_decode(guestLoginData);

    if (user === null || user?.tokenType === TokenType.GUEST) {
      // for
      // 1. external supervisor or internal supervisor (who has not logged in),
      //    should set localStorage
      // 2. external supervisor but has other token
      //    (eg. also a co-supervisor of another applicant and just done the declaration for he/she)
      //    should override the localStorage

      localStorage.setItem('tokens', guestLoginData);
      setUser?.(newUser);
    } else {
      // for supervisor who has logged in,  should not replace the prev token
      setUser?.({
        ...user,
        userInfo: {
          ...user?.userInfo,
          emailAddress, // keep emailAddress in case chief supervisor fill in different email from SSO
        },
      });
    }

    setCurrentRole?.(ROLES_MODULE.SUPERVISOR);
    // then redirect to route protected path
    navigate(`/nomination/co/${applicationId}/${nominationId}`);
  }

  if (error)
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );

  return <>{loading && <Loading />}</>;
};
